import React,{useState}  from 'react'
import styled from "styled-components"
import { HashLink as Link} from "react-router-hash-link";

const Ul = styled.ul`
    display: flex;
    padding:1em 0;
    list-style: none;
    flex-flow: row nowrap;
    z-index:5;
    transition: 2s;

    li {
        padding: 0.6em 1em;
        font-weight: 800;
        font-size: 1.5em;
      }

     li:hover{
        background-color:#56AB46;
        color:white;
      }

      li:active{
        background-color:#56AB46;
        color:white;
      }

      @media (max-width:768px){
          margin-top:65px;
          width:80%;
          flex-flow:column nowrap;
          position:fixed;
          top:0;
          right: 0;    
          background-color:white;
          
          li{
              display:flex;
              justify-content:center;
              width:100%;
          }

          li:hover{
            color:#56AB46;
            background-color:whitesmoke;
          }
          
          li:active{
            color:#56AB46;  
            background-color:whitesmoke;
          }
      }
    `

const RightNav = () => {

  const[open,setOpen] = useState(false) 
 

  return (
  <>
    <Ul >
      <Link smooth to="#home" >
        <li onClick={() => setOpen(!open)}>Home</li>
      </Link> 
       
      <Link  smooth to="#ourstory">
        <li>Story</li>
      </Link> 

      <Link smooth to="#whyus">
        <li>Why Us</li>
      </Link> 

      <Link smooth to="#contacts">
        <li >Contacts</li>
      </Link> 
    </Ul>
  </>
  )
}


export default RightNav